import { useDispatch, useSelector } from "react-redux";
import i18next from "i18next";
import { useTranslation } from "react-i18next";

const Result = () => {
  const dispatch = useDispatch();
  const pageState = useSelector((state) => state.importDatasetPage);
  const resultApiUrl = pageState.resultApiUrl;
  const resultDatasetId = pageState.resultDatasetId;
  const resultInsertedRows = pageState.resultInsertedRows;
  const resultMessage = pageState.resultMessage;
  const { t } = useTranslation();

  return (
    <div className={`result-page`}>
      {resultMessage}

      <div>
        <br />
        {t("datasets.importdataset.notify")}
        <br />
      </div>

      <br />
      <div>
        <b>{t("datasets.importdataset.dataimport1")}</b>{t("datasets.importdataset.dataimport2")}
      </div>
      <ul>
        <li>{t("datasets.importdataset.upload2")}</li>
        <li>{t("datasets.importdataset.connection")}</li>
        <li>
          {t("datasets.importdataset.invoke")}
          {resultApiUrl} {t("datasets.importdataset.invoke1")}
        </li>
        <li>
          {t("datasets.importdataset.invoke2")}
        </li>
      </ul>
    </div>
  );
};

export default Result;
